import { render, staticRenderFns } from "./CarInfo.vue?vue&type=template&id=64b3f0f5&scoped=true"
import script from "./CarInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./CarInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CarInfo.vue?vue&type=style&index=0&id=64b3f0f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b3f0f5",
  null
  
)

export default component.exports